import { render } from "./ExportCustomerModal.vue?vue&type=template&id=12cc63f2&ts=true"
import script from "./ExportCustomerModal.vue?vue&type=script&lang=ts"
export * from "./ExportCustomerModal.vue?vue&type=script&lang=ts"

import "./ExportCustomerModal.vue?vue&type=style&index=0&id=12cc63f2&lang=scss"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__